/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class RegisteredDocument {
  baseApi = ENV.BASE_API;

  async getRegisteredDocuments(studentId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_DOCUMENT}/${studentId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createRegisteredDocument(accessToken, registeredDocumentData) {
    try {
      const formData = new FormData();
      Object.keys(registeredDocumentData).forEach((key) => {
        formData.append(key, registeredDocumentData[key]);
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_DOCUMENT}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateRegisteredDocument(
    accessToken,
    registeredDocumentId,
    registeredDocumentData
  ) {
    try {
      const formData = new FormData();
      Object.keys(registeredDocumentData).forEach((key) => {
        formData.append(key, registeredDocumentData[key]);
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_DOCUMENT}/${registeredDocumentId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteRegisteredDocument(accessToken, registeredDocumentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTERED_DOCUMENT}/${registeredDocumentId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
